import { render, staticRenderFns } from "./bettingpoints.vue?vue&type=template&id=be81d588&"
import script from "./bettingpoints.vue?vue&type=script&lang=js&"
export * from "./bettingpoints.vue?vue&type=script&lang=js&"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./bettingpoints.vue?vue&type=style&index=1&id=be81d588&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports